
/* injects from baggage-loader */

'use strict';

const indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

const moduleEditorDragPanel = angular.module('services.layoutEditor.editorDragPanel', [
  'services.editorNamespace',
  'services.layoutEditor.blockEditDialog'
]);

moduleEditorDragPanel.factory('editorDragPanel', [
  '$rootScope', '$timeout', '$injector', 'ns', 'blockEditDialog', 'Section', 'SectionLesson', 'Widget', 'Animation', 'Tutorials', 'TimeMachine', '$interval', '$filter', '$state', 'Modal',
  ($rootScope, $timeout, $injector, ns, blockEditDialog, Section, SectionLesson, Widget, Animation, Tutorials, TimeMachine, $interval, $filter, $state, Modal) => {
    let Y;

    const editorDragPanel = {
      self: this,
      notEditableWidgets: ['spacer'],
      notSettingsWidgets: ['spacer', 'text', 'headline_h1', 'headline_h2', 'headline_h3'],
      cloneSectionDisabled: false,
      initSectionsPanels: function(y, mode) {
        Y = y;
        this.addPanelsSections();
        this.bindSectionsClickable();

        if ((mode === 'editor.section' || mode === 'editor.email') || $rootScope.isCollectionPage) {
          this.deleteRemoveButton();
        }
      },
      initBlocksPanels: function() {
        this.addPanelsBlocks();
      },
      clearDialog: function(fromRemove) {
        if (fromRemove === null || fromRemove === undefined) {
          fromRemove = false;
        }

        // const layoutEditor = $injector.get('layoutEditor');
        angular.element('[ng-controller=\'blockEditDialogCtrl\']').scope().clearDialog();

        const currentTab = $('.etsw-header').scope().currentNavEditorTab;

        this.cancelSection();
        $rootScope.layoutIsEditing = false;

        if (currentTab === 'blockSettings' && !fromRemove) {
          $rootScope.editorNavTab('sections');
          $timeout(function() {
            $('#mini-sections').perfectScrollbar('update');
          });
        }
      },
      destroyBlocksPanels: function() {
        // const layoutEditor = $injector.get('layoutEditor');
        this.clearDialog();

        Y.all(ns.dragPanelClass).remove();
      },
      removeDialog: function(e) {
        const self = this;

        $rootScope.alertDialog({
          title: $filter('translate')('alert.block.removeTitle'),
          text: $filter('translate')('alert.block.removeDescription'),
          accept_text: $filter('translate')('alert.confirm'),
          cancel_text: $filter('translate')('alert.cancel'),
          accept: function() {
            self._onClickRemove(e);
          }
        });

        $rootScope.$apply();
      },
      setSectionTitle: function(section, dp) {
        let title;
        const type = section.section.section_type;

        if (type === 'header' || type === 'footer') {
          const type_ru = type === 'header' ? $filter('translate')('editor.headerPlaceholder.title') : $filter('translate')('editor.footerPlaceholder.title');

          title = (type_ru + ' - ' + section.section.title) || '';
        } else {
          title = section.section.title || '';
        }

        if (Editor.mode !== 'form.page.editor') {
          dp.one('.etdp__title').set('innerHTML', title.toUpperCase());
        }

        dp.addClass(ns.dragPanelSectionClass.substr(1));
      },
      showEditorNav: function() {
        const $eTools = $('.e__tools');

        $eTools.scope().editorNavOpen = true;
        $eTools.scope().$apply();
      },
      showEditorNavWidget: function() {
        const $eTools = $('.e__tools');

        $eTools.scope().editorNavOpenWidget = true;
        $eTools.scope().$apply();
      },
      turnAdaptor: function(e, section) {
        const adaptorEl = e.target.hasClass('et__drag-panel') ? e.target : e.target.ancestor('.et__drag-panel');
        const adaptor = adaptorEl.getData('adaptor');

        section.section.adaptation[adaptor] = !section.section.adaptation[adaptor];

        if (section.section.adaptation[adaptor]) {
          adaptorEl.addClass('et__drag-panel_section-settings_adaptive-active');
        } else {
          adaptorEl.removeClass('et__drag-panel_section-settings_adaptive-active');
        }
      },
      /**
       * Панель секции
       * @param widget
       * @param section
       * @returns {Node}
       */
      dragPanelSectionWithEvents: function(widget, section) {
        if (widget === null || widget === undefined) {
          widget = false;
        }
        if (section === null || section === undefined) {
          section = false;
        }

        const self = this;
        const dp = Y.Node.create(this.dragPanelSectionNode());
        const settingsButton = dp.one('.etdp__button_settings');

        settingsButton.on('click', function(e) {
          $rootScope.editorNavTab('blockSettings');
          self.showEditorNav();
          e.target = e.target.ancestor(ns.sectionClass);
          self._onClickEditSection(e);
        });

        const settingsText = $filter('translate')('editor.section.panelSettingsLabel');
        const editText = $filter('translate')('editor.section.edit');

        dp.one('.et__drag-panel_section-settings-text').append(settingsText);
        dp.one('.et__drag-panel-backdrop').append(
            '<div class="et__drag-panel-backdrop_edit"> ' +
              '<svg width="16" height="16" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" class="icon__fill icon__stroke icon__inline inline-wrapper">' +
                '<g><path d="M19.499 11.477v12h-19v-21h14"/><path d="M12.823 14.029l-4.949 2.121 2.121-4.951 10.678-10.677 2.828 2.828z"/></g>' +
              '</svg>' +
              '<div class="et__drag-panel-backdrop_edit-text">' + editText + '</div>' +
            '</div>'
        );

        if (this.isMixerMode()) {
          if (section.section.interactive) {
            dp.one('.switch').removeClass('hidden');
            dp.one('.switch_drag-panel input')._node.checked = section.section.in_mixer_active;
            dp.one('.switch_drag-panel input').on('change', function() {
              self._onClickMixerToggleSection(this, section.section);
            });

            if (!section.section.in_mixer_active) {
              section.addClass('widget-wrapper_mixer-disabled');
            }
          } else {
            dp.one('.et__drag-panel_section').setStyles({display: 'none'});
          }
        }

        if (section._node.tagName.toLowerCase() === 'section' && !Editor.option) {
          const cloneButton = Y.Node.create(
              '<div class="etdp__button etdp__button_clone">' +
                '<svg class="icon__fill icon__stroke icon__inline" width="16" height="16" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">' +
                  '<path d="M12.007 1.007l-.007-.007h-8v21h14v-21h-6zm-1.007 6.993v8m4-4h-8m7.5 10.057v2.443h-14v-20h3"/>' +
                '</svg> ' +
              '</div>'
          );

          cloneButton.on('click', this._onClickCloneSection, this);
          dp.one(ns.dragPanelTable).append(cloneButton);

          // Добавление кнопки FavoriteSection
          const favoriteButton = Y.Node.create(this.dragPanelFavoriteNode);
          favoriteButton.on('click', this._onClickCreateFavoriteSection, this);
          dp.one(ns.dragPanelTable).append(favoriteButton);
        }

        if (Editor.option) {
          dp.one('.etdp__button_drag').remove();
          dp.one('.et__drag-panel_section-settings_adaptive-wrapper').remove();
        }

        if (section.section.for_email) {
          dp.one('.et__drag-panel_section-settings_adaptive-wrapper').remove();
        } else {
          if (!Editor.option) {
            _.map(section.section.adaptation, function(enabled, platform) {
              if (enabled) {
                dp.one('.et__drag-panel_section-settings_adaptive-' + platform).addClass('et__drag-panel_section-settings_adaptive-active');
              }
            });
            dp.all('[data-adaptor]').each(function(button) {
              button.on('click', function(e) {
                self.turnAdaptor(e, section);
              });
            });
          }
        }

        const removeButton = Y.Node.create(this.dragPanelRemoveNode);
        removeButton.on('click', this.removeDialog, this);

        if (!Editor.option) {
          dp.one(ns.dragPanelTable).append(removeButton);
        }

        if (section && section.section) {
          this.setSectionTitle(section, dp);
        }

        if (Editor.mode === 'form.page.editor') {
          dp.one('.et__drag-panel_section-settings_adaptive-wrapper').remove();
          dp.one('.et__drag-panel_section').remove();
          if (!section.section.style_attributes.maxWidth) {
            section.section.wrapper_style_attributes.maxWidth = '500px';
            section.section.style_attributes.padding = '0px 0px 0px 0px';
          }
        }

        if (Editor.mode === 'site.page.editor') {
          const btnPower = dp.one('.etdp__button_power');
          const sectionEl = Y.one('[data-section-id=\'' + section.section.id + '\']');
          const sectionType = section.section.section_type;

          if (sectionType === 'header') {
            btnPower.removeClass('hidden');

            if ($rootScope.currentSite.header_enabled) {
              btnPower.addClass('active');
            } else {
              sectionEl.addClass('str-section_darkened');
            }
          }

          if (sectionType === 'footer') {
            btnPower.removeClass('hidden');
            if ($rootScope.currentSite.footer_enabled) {
              btnPower.addClass('active');
            } else {
              sectionEl.addClass('str-section_darkened');
            }
          }

          btnPower.on('click', function(e) {
            self._onClickEnableSection(e, sectionEl, sectionType);
          });
        }

        return dp;
      },
      /**
       *
       * @param e
       * @param sectionEl
       * @param sectionType
       * @private
       */
      _onClickEnableSection: function(e, sectionEl, sectionType) {
        let isEnabled;

        if (sectionType === 'header') {
          isEnabled = !$rootScope.currentSite.header_enabled;
          $rootScope.currentSite.header_enabled = isEnabled;
          this._toggleTurn(e, isEnabled, sectionEl);
        }

        if (sectionType === 'footer') {
          isEnabled = !$rootScope.currentSite.footer_enabled;
          $rootScope.currentSite.footer_enabled = isEnabled;
          this._toggleTurn(e, isEnabled, sectionEl);
        }
      },
      /**
       *
       * @param e
       * @param isEnabled
       * @param sectionEl
       * @private
       */
      _toggleTurn: function(e, isEnabled, sectionEl) {
        const btnPowerEl = e.target.hasClass('etdp__button_power') ? e.target : e.target.ancestor('.etdp__button_power');

        if (isEnabled) {
          btnPowerEl.addClass('active');
          sectionEl.removeClass('str-section_darkened');
        } else {
          btnPowerEl.removeClass('active');
          sectionEl.addClass('str-section_darkened');
        }
      },
      /**
       *
       * @param input
       * @param section
       * @private
       */
      _onClickMixerToggleSection: function(input, section) {
        const layoutEditor = $injector.get('layoutEditor');
        const sectionEl = Y.one('[data-section-id=\'' + section.id + '\']');

        section.in_mixer_active = input._node.checked;

        layoutEditor.updateSectionEtag(angular.copy(section));

        if (Editor.option === 'lesson.page.mixer') {
          SectionLesson.updateForMixer({
            id: section.id,
            in_mixer_active: section.in_mixer_active
          }).then($rootScope.publishSite);
        } else {
          Section.update_for_mixer({
            id: section.id,
            in_mixer_active: section.in_mixer_active
          }).then($rootScope.publishSite);
        }

        if (!section.in_mixer_active) {
          sectionEl.addClass('widget-wrapper_mixer-disabled');
          this.cancelSection();
        } else {
          sectionEl.removeClass('widget-wrapper_mixer-disabled');
        }
      },
      /**
       * Панель виджета
       * @param widget
       * @param section
       * @returns {Node}
       */
      dragPanelWidgetWithEvents: function(widget, section) {
        if (widget === null || widget === undefined) {
          widget = false;
        }
        if (section === null || section === undefined) {
          section = false;
        }

        const self = this;
        const dp = Y.Node.create(this.dragPanelNode());

        dp.one('.etdp__title').set('innerHTML', widget.name);
        dp.addClass(ns.dragPanelWidgetClass.substr(1));

        const settingsButton = Y.Node.create(this.dragPanelSettingsNode);
        settingsButton.on('click', function(e) {
          $rootScope.editorNavTab('blockSettings');
          self.showEditorNavWidget();
          e.target = e.target.ancestor(ns.blockClass);
          self._onClickWidgetSettings(e);
        });

        const ref = widget.type;
        if (indexOf.call(this.notSettingsWidgets, ref) < 0) {
          dp.one(ns.dragPanelTable).append(settingsButton);
        }

        if (this.isMixerMode() && widget.interactive) {
          dp.one('.switch').removeClass('hidden');
          dp.one('.switch_drag-panel input')._node.checked = widget.in_mixer_active;
          dp.one('.switch_drag-panel input').on('change', function() {
            self._onClickMixerToggleWidget(this, widget);
          });

          if (!widget.in_mixer_active) {
            Y.one('.str-bw_' + widget.id).addClass('widget-wrapper_mixer-disabled');
          }
        }

        const cloneButton = Y.Node.create(
            '<div class="etdp__button etdp__button_clone">' +
              '<svg class="icon__fill icon__stroke icon__inline" width="16" height="16" viewBox="0 0 19 25" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M12.007 1.007l-.007-.007h-8v21h14v-21h-6zm-1.007 6.993v8m4-4h-8m7.5 10.057v2.443h-14v-20h3"/>' +
              '</svg> ' +
            '</div>'
        );
        cloneButton.on('click', this._onClickCloneWidget, this);

        if (!Editor.option) {
          dp.one(ns.dragPanelTable).append(cloneButton);
        }

        const removeButton = Y.Node.create(this.dragPanelRemoveNode);
        removeButton.on('click', this.removeDialog, this);

        if (!Editor.option) {
          dp.one(ns.dragPanelTable).append(removeButton);
        }

        return dp;
      },
      /**
       *
       * @param input
       * @param widget
       * @private
       */
      _onClickMixerToggleWidget: function(input, widget) {
        const layoutEditor = $injector.get('layoutEditor');
        const widgetEl = Y.one('.str-bw_' + widget.id);

        widget.in_mixer_active = input._node.checked;
        $rootScope.widgetsIsMixer = {};
        $rootScope.widgetsIsMixer[widget.id] = widget.in_mixer_active;

        const sectionId = blockEditDialog.getSectionId({id: widget.id});

        Widget.updateForMixer(sectionId, {
          id: widget.id,
          in_mixer_active: widget.in_mixer_active
        });

        $timeout(function() {
          const updatedSection = angular.copy(layoutEditor.layout.section);
          layoutEditor.updateSectionEtag(updatedSection);

          $rootScope.publishSite();
        }, 200);

        if (!widget.in_mixer_active) {
          widgetEl.addClass('widget-wrapper_mixer-disabled');
        } else {
          widgetEl.removeClass('widget-wrapper_mixer-disabled');
        }
      },
      /**
       *
       * @param section
       * @returns {boolean}
       */
      bindSectionClickable: function(section) {
        const ref = section.section.section_type;

        if ($state.includes('site.collection') && (ref === 'footer' || ref === 'header')) {
          return false;
        }

        let intBlockExists = false;
        section.all('.str-block').each(function(block) {
          if (block.widget && block.widget.interactive) {
            intBlockExists = true;
          }
        });

        if (!section.section.interactive && this.isMixerMode() && !intBlockExists) {
          return false;
        }

        section.detach('click', this._onClickEditSection, this);
        section.on('click', this._onClickEditSection, this);
      },
      bindSectionsClickable: function() {
        Y.all(ns.sectionClass).each(this.bindSectionClickable, this);
      },
      /**
       *
       * @param block
       * @returns {boolean}
       */
      addPanelsBlock: function(block) {
        if (!block.widget) {
          return false;
        }
        if (!block.widget.interactive && this.isMixerMode()) {
          return false;
        }

        if (this.isMixerMode()) {
          block.addClass('str-widget__mixer');
        }

        // const layoutEditor = $injector.get('layoutEditor');
        const dragPanel = this.dragPanelWidgetWithEvents(block.widget);

        if (block.one(ns.dragPanelClass)) {
          block.one(ns.dragPanelClass).remove();
        }

        block.prepend(dragPanel);
        block.detach('mouseup', this._onClickWidgetSettings, this);
        block.on('mouseup', this._onClickWidgetSettings, this);
      },
      addPanelsBlocks: function() {
        const layoutEditor = $injector.get('layoutEditor');

        layoutEditor.layout.all(ns.blockClass).each(this.addPanelsBlock, this);
      },
      /**
       *
       * @param e
       * @private
       */
      _onClickCloneWidget: function(e) {
        const layoutEditor = $injector.get('layoutEditor');
        const insertBlockMenu = $injector.get('insertBlockMenu');
        const blocksBuilder = $injector.get('blocksBuilder');
        const blockDragDrop = $injector.get('blockDragDrop');
        const sectionId = layoutEditor.layout.section.id;
        const widgetId = e.target.ancestor(ns.blockClass).widget.id;
        const widgetMin_size = e.target.ancestor(ns.blockClass).widget.min_size;
        const clone = {};
        const type = e.target.ancestor(ns.blockClass).widget.type;
        const node = blocksBuilder.createBlock(ns.blockLoader, type);
        const dropTarget = e.target.ancestor(ns.blockClass);
        // const dropTargetRow = dropTarget.ancestor(ns.rowClass);

        clone.min_size = widgetMin_size;
        node.widget = {
          min_size: widgetMin_size
        };

        const availColSize = blocksBuilder.getAvailableColSize(e.target.ancestor(ns.rowClass), e.target.ancestor(ns.colClass), false, true);
        if (availColSize >= widgetMin_size) {
          const direction = 'right';
          blockDragDrop.insertSideOverride(direction, node, dropTarget, clone);
        }

        if (availColSize < widgetMin_size) {
          const direction = 'bottom';
          blocksBuilder.insertRow(direction, node, dropTarget);
        }

        blockDragDrop.clean();
        insertBlockMenu.updateWidgetsOnResize();
        Widget.clone(sectionId, widgetId).then(function(clone) {
          insertBlockMenu.afterCreateWidget(node, clone, false, type, false);
          layoutEditor.setHandleBlocks(node);
          insertBlockMenu.updateWidgetsOnResize();
        });
      },
      /**
       *
       * @param e
       * @returns {boolean}
       * @private
       */
      _onClickCloneSection: function(e) {
        if (this.cloneSectionDisabled) {
          return false;
        }
        const editorNavSections = $injector.get('editorNavSections');
        editorNavSections.newSectionType = 'default';
        const sectionEl = e.target.ancestor(ns.sectionClass);
        // const sectionId = sectionEl.section.id;
        editorNavSections.cloning = true;
        const newSection = editorNavSections.buildNewSection(e.target.ancestor(ns.sectionClass), true);

        sectionEl.insert(newSection, 'after');
        newSection.addClass('str-cloned__section');
        Animation.scrollTo($(newSection._node));
        editorNavSections.bindSectionOnDropInTemplate(newSection);
      },

      _onClickCreateFavoriteSection: function(e) {
        const sectionEl = e.target.ancestor(ns.sectionClass);

        Modal.favoriteSectionSettings(sectionEl.section);
      },

      removeAllSettingsClasses: function() {
        Y.all(ns.blockSettingsEditing).removeClass(ns.blockSettingsEditing.substr(1));
      },
      /**
       *
       * @param e
       * @returns {*}
       */
      addActiveSettingsClass: function(e) {
        const blockEditDialog = $injector.get('blockEditDialog');
        this.removeAllSettingsClasses();
        const block = blockEditDialog.findBlockOrSection(e);
        block.addClass(ns.blockSettingsEditing.substr(1));
        if (Editor.mode === 'editor.email' || Editor.mode === 'form.page.editor') {
          block.addClass(ns.blockSettingsEditing_noshadow);
        }
      },
      /**
       *
       * @param value
       * @returns {jQuery}
       */
      htmlDecode: function(value) {
        return $('<div/>').html(value).text();
      },
      /**
       *
       * @param value
       * @returns {jQuery}
       */
      htmlEncode: function(value) {
        return $('<div/>').text(value).html();
      },
      /**
       *
       * @param e
       * @returns {boolean}
       * @private
       */
      _onClickWidgetSettings: function(e) {
        const blockDropOverlays = $injector.get('blockDropOverlays');
        const dragPanel = e.target.ancestor(ns.dragPanelTable);

        if (!blockDropOverlays.target) {
          blockDropOverlays.createOverlays(false, e);
          e.target = blockDropOverlays.getTarget(e);
        } else {
          e.target = blockDropOverlays.target;
        }

        const widgetType = e.target.ancestor(ns.blockClass).widget.type;

        if (indexOf.call(this.notEditableWidgets, widgetType) >= 0) {
          return false;
        }

        const layoutEditor = $injector.get('layoutEditor');
        if (!dragPanel && e.target) {
          const blockDragDrop = $injector.get('blockDragDrop');
          this._onClickSettings(e);
          if (widgetType !== 'text' && widgetType !== 'headline_h1' && widgetType !== 'headline_h2' && widgetType !== 'headline_h3') {
            this.showEditorNavWidget();
          } else {
            const $eTools = $('.e__tools');

            $eTools.scope().editorNavOpenWidgetText = true;
            $eTools.scope().$apply();

            if (CKEDITOR.instances[e.target.ancestor(ns.blockClass).one(ns.widgetWrapperClass)._yuid]) {
              const CKinstance = CKEDITOR.instances[e.target.ancestor(ns.blockClass).one(ns.widgetWrapperClass)._yuid];
              const focusManager = new CKEDITOR.focusManager(CKinstance);
              focusManager.focus();
              e.target.ancestor(ns.blockClass).one(ns.widgetWrapperClass).focus();
            }
          }
          layoutEditor.layout.addClass('et__drag-panel-wrapper_widget-editing');
          blockDropOverlays.target = void 0;
          blockDragDrop.widgetsPreCapture();
        }
      },
      /**
       *
       * @param e
       * @private
       */
      _onClickSettings: function(e) {
        const insertBlockMenu = $injector.get('insertBlockMenu');

        insertBlockMenu.hide();
        this.addActiveSettingsClass(e);

        const blockEditDialogCtrl = $('[ng-controller="blockEditDialogCtrl"]').scope();
        blockEditDialogCtrl.setValues(e);
        blockEditDialog.setPanelTitle(blockEditDialog.currentBlockJson);

        if (!blockEditDialogCtrl.$$phase) {
          blockEditDialogCtrl.$apply();
        }
      },
      /**
       *
       * @param section
       * @returns {boolean}
       */
      addPanelSection: function(section) {
        const ref = section.section.section_type;
        if ($state.includes('site.collection') && (ref === 'footer' || ref === 'header')) {
          return false;
        }

        let intBlockExists = false;
        section.all('.str-block').each(function(block) {
          if (block.widget && block.widget.interactive) {
            intBlockExists = true;
          }
        });

        if (!section.section.interactive && this.isMixerMode() && !intBlockExists) {
          return false;
        }

        if (this.isMixerMode()) {
          section.addClass('str-section__mixer');
        }

        const dragPanel = this.dragPanelSectionWithEvents(false, section);
        dragPanel.addClass(ns.dragPanelSectionClass.substr(1));
        section.prepend(dragPanel);
      },
      addPanelsSections: function() {
        Y.all('.tpl-wrapper > ' + ns.sectionClass).each(this.addPanelSection, this);
      },
      /**
       * Событие редактирования секции
       * @param e
       * @param layoutEditor
       */
      startEditingLayout: function(e, layoutEditor) {
        const layout = e.target.ancestor(ns.sectionClass) || e.target;

        if (layout) {
          layout.one(ns.dragPanelClass).addClass('et__drag-panel-wrapper_editing');
          layout.addClass('section-editing');
          layoutEditor.initEditingLayout(layout);
        }
      },
      /**
       * Обработка события клика по секции
       * @param e
       * @param withCapture
       * @param withSave
       * @returns {boolean}
       * @private
       */
      _onClickEditSection: function(e, withCapture, withSave) {
        if (withCapture === null || withCapture === undefined) {
          withCapture = true;
        }
        if (withSave === null || withSave === undefined) {
          withSave = true;
        }
        const self = this;
        const saveSection = $('[ng-controller=\'EditorNavigationCtrl\']').scope().saveSectionWithoutTimeout;
        const currentSection = $('[ng-controller=\'blockEditDialogCtrl\']').scope().section;
        const layoutEditor = $injector.get('layoutEditor');
        const targetSection = e.target.ancestor(ns.sectionClass);
        const targetBlock = e.target.ancestor(ns.blockClass) || e.target.hasClass(ns.blockClass.substr(1));
        const dragPanel = e.target.ancestor(ns.dragPanelTable);

        if (targetBlock) {
          return false;
        }

        if (layoutEditor.layout && withSave && currentSection) {
          saveSection(angular.copy(currentSection));
        }

        if (!layoutEditor.layout && !dragPanel) {
          self.startEditingLayout(e, layoutEditor);
          self._onClickSettings(e);
          return true;
        }

        if (layoutEditor.layout) {
          const editingLayoutId = layoutEditor.layout.section.id;
          const clickedLayoutId = targetSection && targetSection.section.id || e.target.section.id;

          if (editingLayoutId === clickedLayoutId && !dragPanel && !targetBlock) {
            self._onClickSettings(e);
            layoutEditor.layout.removeClass('et__drag-panel-wrapper_widget-editing');
          } else if (!dragPanel) {
            self.cancelSection();
            self.startEditingLayout(e, layoutEditor);
            self._onClickSettings(e);
          }
        }
      },
      cancelSection: function() {
        const layoutEditor = $injector.get('layoutEditor');
        const layout = layoutEditor.layout;
        if (!layout) {
          return false;
        }

        layout.one(ns.dragPanelClass).removeClass('et__drag-panel-wrapper_editing');

        const Text = $injector.get('Text');
        Text.destroy();
        if (layout) {
          layout.removeClass('section-editing');
        }

        layoutEditor.cancelEditingLayout(layout);
      },
      saveLayout: function() {
        const layoutEditor = $injector.get('layoutEditor');
        layoutEditor.save();
      },
      afterLastWidgetRemove: function(widget) {
        const builder = $injector.get('blocksBuilder');
        const insertBlockMenu = $injector.get('insertBlockMenu');
        const widgetLength = widget.ancestor(ns.sectionClass).all(ns.blockClass).size();

        if (widgetLength === 1) {
          const newBlock = insertBlockMenu.createAndInitBlock({}, widget.ancestor(ns.rowClass), 'spacer');
          builder.insertRow('top', newBlock, widget.ancestor(ns.rowClass));
        }
      },
      showDropBackdrop: function() {
        Y.one('.str-drop-backdrop').addClass('no-sections');
        Y.one('.str-drop-backdrop').removeClass('ng-hide');
      },
      afterLastSectionRemove: function() {
        const length = Y.all('section:not(.str-removed)').size();
        if (!length) {
          this.showDropBackdrop();
        }
      },
      /**
       *
       * @param widget
       */
      setSectionSettingsAfterWidgetRemove: function(widget) {
        const e = {};
        e.target = widget.ancestor(ns.sectionClass);

        this._onClickSettings(e);
      },
      captureRemove: function(section) {
        const sectionHTML = section.get('outerHTML');
        const prevSectionId = section.previous() && section.previous().getData('section-id') || undefined;

        TimeMachine.capture('removeSection', section.section, sectionHTML, prevSectionId);
      },
      /**
       *
       * @param section
       * @param withCapture
       */
      removeSection: function(section, withCapture) {
        if (withCapture === null || withCapture === undefined) {
          withCapture = true;
        }

        const self = this;
        // const sectionId = section.section.id;

        section.section.removed = true;
        Animation.slideUp(section);

        if (withCapture) {
          this.captureRemove(section);
        }

        $timeout(function() {
          section.addClass('str-removed');
          section.edited = true;
          $rootScope.toggleCommonSections();
          self.clearDialog(true);
          self.afterLastSectionRemove();
        }, 200);

        $(window).trigger('scroll');
      },
      /**
       *
       * @param widget
       */
      removeWidget: function(widget) {
        const insertBlockMenu = $injector.get('insertBlockMenu');
        const layoutEditor = $injector.get('layoutEditor');
        const blockDragDrop = $injector.get('blockDragDrop');

        this.afterLastWidgetRemove(widget);
        this.setSectionSettingsAfterWidgetRemove(widget);

        widget.remove();
        blockDragDrop.clean();
        insertBlockMenu.updateWidgetsOnResize();

        $timeout(function() {
          layoutEditor.save();
        }, 200);

        blockDragDrop.widgetsCapture();
      },
      /**
       *
       * @param e
       * @private
       */
      _onClickRemove: function(e) {
        const widget = e.target.ancestor(ns.blockClass);
        const blocksBuilder = $injector.get('blocksBuilder');
        const layoutEditor = $injector.get('layoutEditor');
        const self = this;

        if (widget) {
          const col = widget.ancestor(ns.colClass);
          const sectionId = layoutEditor.layout.section.id;
          const widgetJson = widget.widget;

          widgetJson.removed = true;
          Widget.update(sectionId, widgetJson);

          if (col.all(ns.blockClass).size() === 1) {
            // const colSize = blocksBuilder.getColSize(col);
            col.setStyles({
              opacity: 0,
              width: 0
            });
            blocksBuilder.updateColSize(widget.ancestor(ns.colClass), 0);
          }

          $timeout(function() {
            self.removeWidget(widget);
          }, 200);
        } else {
          const section = e.target.ancestor(ns.sectionClass);
          this.removeSection(section);
        }
      },
      _mouseenter: function(e) {
        const target = e.target.ancestor(ns.sectionClass);
        if (target) {
          target.addClass('str-section-hover');
        }
      },
      _mouseleave: function(e) {
        const target = e.target.ancestor(ns.sectionClass);
        if (target) {
          target.removeClass('str-section-hover');
        }
      },
      destroy: function() {
        Y.all(ns.dragPanelClass).remove();
      },
      deleteRemoveButton: function() {
        Y.all('section ' + ns.dragPanelRemoveButton).remove();
      },
      dragPanelSettingsNode: (
          '<div class="etdp__button etdp__button_settings">' +
            '<svg width="16" height="16" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" class="icon__fill icon__stroke icon__inline">' +
              '<g><path d="M19.499 11.477v12h-19v-21h14"/><path d="M12.823 14.029l-4.949 2.121 2.121-4.951 10.678-10.677 2.828 2.828z"/></g>' +
            '</svg>' +
          '</div>'
      ),
      dragPanelRemoveNode: (
          '<div class="etdp__button etdp__button_remove">' +
            '<svg class="icon__fill icon__stroke icon__inline" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M3.5 23.5h16v-20h-16zm4-20h8v-3h-8zm-6.5 0h22m-15.5 3.5v12m4-12v12m4-12v12" />' +
            '</svg>' +
          '</div>'
      ),
      dragPanelFavoriteNode: (
          '<div class="etdp__button etdp__button_favorite">' +
            '<svg width="16" height="16" class="icon__fill icon__stroke icon__inline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.867 53.867" enable-background="new 0 0 53.867 53.867">' +
              '<path d="M26.934 1.318l8.322 16.864 18.611 2.705-13.467 13.126 3.179 18.536-16.645-8.751-16.646 8.751 3.179-18.536-13.467-13.126 18.611-2.705z" stroke="#979797" stroke-width="4" fill="none"></path>' +
            '</svg>' +
          '</div>'
      ),
      dragPanelSectionNode: function() {
        return (
            "<div class='et__drag-panel-wrapper'> " +
              "<div class='et__drag-panel-backdrop'></div> " +
              "<div class='et__drag-panel et__drag-panel_section-settings'> " +
                "<div class='etdp__button etdp__button_settings'>" +
                  "<svg class='et__drag-panel_section-settings-icon' width='18' height='18' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>" +
                    "<path d='M20.254 13.5h3.246v-3h-3.247c-.209-.867-.551-2.181-1.003-2.922l2.296-2.295-2.829-2.829-2.297 2.296c-.74-.452-2.053-.793-2.92-1.002v-3.248h-3v3.248c-.867.209-2.181.55-2.921 1.002l-2.297-2.296-2.829 2.829 2.297 2.296c-.452.74-.794 2.054-1.004 2.921h-3.246v3h3.246c.21.867.552 2.181 1.004 2.921l-2.297 2.297 2.829 2.828 2.296-2.297c.741.453 2.055.795 2.922 1.005v3.246h3v-3.246c.867-.21 2.181-.552 2.92-1.004l2.298 2.296 2.828-2.828-2.296-2.297c.452-.74.794-2.054 1.004-2.921zm-3.754-1.5c0 2.486-2.015 4.5-4.5 4.5s-4.5-2.014-4.5-4.5c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5z' fill='none' stroke='#FFF'/>" +
                  "</svg> " +
                  "<span class='et__drag-panel_section-settings-text'></span> " +
                "</div> " +
              "</div> " +
              "<div class='et__drag-panel_section-settings_adaptive-wrapper'> " +
                "<div data-adaptor='desktop' class='et__drag-panel et__drag-panel_section-settings et__drag-panel_section-settings_adaptive-desktop'> " +
                  "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' height='18px' width='20px' viewBox='0 0 560 500' enable-background='new 0 0 560 500' xml:space='preserve'> " +
                    "<path fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' d='M471.2,0H88.8C40.2,0,0.6,39.6,0.6,88.2v264.7 c0,48.7,39.6,88.3,88.2,88.3h32.1c-1.6,4.6-2.7,9.5-2.7,14.7c0,24.4,19.7,44.1,44.1,44.1h235.3c24.4,0,44.1-19.7,44.1-44.1 c0-5.2-1.1-10.1-2.7-14.7h32.2c48.6,0,88.2-39.6,88.2-88.3V88.2C559.4,39.6,519.8,0,471.2,0z M500.6,352.9 c0,16.3-13.2,29.5-29.4,29.5H88.8c-16.3,0-29.4-13.2-29.4-29.5V88.2c0-16.2,13.1-29.4,29.4-29.4h382.4c16.2,0,29.4,13.2,29.4,29.4 V352.9z'/> " +
                  "</svg> " +
                "</div> " +
                "<div data-adaptor='tablet' class='et__drag-panel et__drag-panel_section-settings et__drag-panel_section-settings_adaptive-tablet'> " +
                  "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' height='18px' width='15px' viewBox='0 0 420 500' enable-background='new 0 0 420 500' xml:space='preserve'> " +
                    "<path fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' d='M335,0H85C39.1,0,1.7,37.4,1.7,83.3v333.4 C1.7,462.6,39.1,500,85,500h250c45.9,0,83.3-37.4,83.3-83.3V83.3C418.3,37.4,380.9,0,335,0z M210,458.3c-11.5,0-20.9-9.4-20.9-20.9 c0-11.5,9.4-20.8,20.9-20.8c11.5,0,20.9,9.3,20.9,20.8C230.9,449,221.5,458.3,210,458.3z M362.8,388.9H57.2V83.3 C57.2,68,69.6,55.5,85,55.5h250c15.4,0,27.8,12.5,27.8,27.8V388.9z'/> " +
                  "</svg> " +
                "</div> " +
                "<div data-adaptor='mobile' class='et__drag-panel et__drag-panel_section-settings et__drag-panel_section-settings_adaptive-mobile'> " +
                  "<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' height='18px' width='12px' viewBox='0 0 316 500' enable-background='new 0 0 316 500' xml:space='preserve'> " +
                    "<path fill-rule='evenodd' clip-rule='evenodd' fill='#FFFFFF' d='M250.1,0H65.9C29.6,0,0.1,29.5,0.1,65.8v368.5 c0,36.3,29.5,65.8,65.9,65.8h184.2c36.3,0,65.8-29.5,65.8-65.8V65.8C315.9,29.5,286.4,0,250.1,0z M151.4,460.5 c-18.1,0-32.8-11.8-32.8-26.3c0-14.6,14.7-26.3,32.8-26.3c18.2,0,32.9,11.8,32.9,26.3C184.3,448.8,169.6,460.5,151.4,460.5z M276.5,381.6H39.5V65.8h236.9V381.6z'/> " +
                  "</svg> " +
                "</div> " +
              "</div> " +
              "<div class='etdp__title etdp__title_section'></div> " +
              "<div class='et__drag-panel et__drag-panel_section'> " +
                "<div class='et__drag-panel-table clearfix'> " +
                  "<div class='etdp__button etdp__button_power hidden'> " +
                      "<svg width='33px' height='33px' viewBox='0 0 33 33' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'> " +
                        "<title>" + ($filter('translate')('editor.section.turnOn')) + "</title> " +
                        "<defs></defs> <g id='Page-2-Copy' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'> <g id='85' transform='translate(1.000000, 0.000000)'> " +
                        "<path d='M15,10.9796047 C15,11.5323532 15.4438648,11.9804443 16,11.9804443 L16,11.9804443 C16.5522847,11.9804443 17,11.5254261 17,10.9796047 L17,1.00083963 C17,0.448091163 16.5561352,-1.77635684e-15 16,-1.77635684e-15 L16,-1.77635684e-15 C15.4477153,-1.77635684e-15 15,0.45501823 15,1.00083963 L15,10.9796047 L15,10.9796047 Z' id='Rectangle-509' fill='#ffffff' fill-rule='evenodd'></path> " +
                        "<path d='M0.871869243,21.5794795 C3.89414939,29.8831259 13.075627,34.1645192 21.3792735,31.1422391 C29.6829199,28.119959 33.9643133,18.9384813 30.9420331,10.6348349 C30.7531406,10.115857 30.1792982,9.84826989 29.6603203,10.0371624 C29.1413424,10.2260549 28.8737554,10.7998973 29.0626479,11.3188752 C31.707143,18.5845658 27.9609238,26.6183587 20.6952332,29.2628539 C13.4295425,31.907349 5.39574961,28.1611298 2.75125448,20.8954392 C0.106759355,13.6297485 3.85297851,5.59595561 11.1186692,2.95146048 C11.6376471,2.76256797 11.9052342,2.18872562 11.7163416,1.66974771 C11.5274491,1.15076981 10.9536068,0.883182725 10.4346289,1.07207523 C2.13098242,4.09435538 -2.15041091,13.275833 0.871869243,21.5794795 L0.871869243,21.5794795 L0.871869243,21.5794795 Z M10.4346289,31.1422391 C18.7382753,34.1645192 27.919753,29.8831259 30.9420331,21.5794795 C33.9643133,13.275833 29.6829199,4.09435538 21.3792735,1.07207523 C20.8602956,0.883182725 20.2864532,1.15076981 20.0975607,1.66974771 C19.9086682,2.18872562 20.1762553,2.76256797 20.6952332,2.95146048 C27.9609238,5.59595561 31.707143,13.6297485 29.0626479,20.8954392 C26.4181527,28.1611298 18.3843598,31.907349 11.1186692,29.2628539 C3.85297851,26.6183587 0.106759355,18.5845658 2.75125448,11.3188752 C2.94014699,10.7998973 2.67255991,10.2260549 2.15358201,10.0371624 C1.6346041,9.84826989 1.06076175,10.115857 0.871869243,10.6348349 C-2.15041091,18.9384813 2.13098242,28.119959 10.4346289,31.1422391 L10.4346289,31.1422391 L10.4346289,31.1422391 Z' id='Oval-45' fill='#ffffff' fill-rule='nonzero'></path> " +
                        "</g> </g> " +
                      "</svg> " +
                  "</div> " +
                  "<label for='interactive" + ((new Date).getTime()) + "' class='switch switch_drag-panel hidden'> " +
                    "<input type='checkbox' id='interactive" + ((new Date).getTime()) + "' class='switch-input ng-pristine ng-untouched ng-valid'> " +
                    "<span data-on='' data-off='' class='switch-label'></span>" +
                    "<span class='switch-handle'></span> " +
                  "</label> " +
                  "<div class='etdp__button etdp__button_drag icon-drag'> " +
                    "<svg class='icon__fill icon__stroke icon__inline' width='12' height='12' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>" +
                      "<path d='M6.148 1.003l-.005-.003h-5.143v9h9v-9h-3.857zm13 0l-.005-.003h-5.143v9h9v-9h-3.857zm-13 13l-.005-.003h-5.143v9h9v-9h-3.857zm13 0l-.005-.003h-5.143v9h9v-9h-3.857z'/>" +
                    "</svg> " +
                  "</div> " +
                "</div> " +
              "</div> " +
            "</div>"
        );
      },
      dragPanelNode: function() {
        return (
            "<div class='et__drag-panel-wrapper'> " +
              "<div class='et__drag-panel-backdrop'></div> " +
              "<div class='et__drag-panel'> " +
                "<div class='et__drag-panel-table clearfix'> " +
                  "<div class='etdp__title'></div> " +
                  "<label for='interactive" + ((new Date).getTime()) + "' class='switch switch_drag-panel hidden'> " +
                    "<input type='checkbox' id='interactive" + ((new Date).getTime()) + "' class='switch-input ng-pristine ng-untouched ng-valid'> " +
                    "<span data-on='' data-off='' class='switch-label'></span>" +
                    "<span class='switch-handle'></span> " +
                  "</label> " +
                "</div> " +
              "</div> " +
            "</div>"
        );
      },

      isMixerMode: function() {
        return ['site.page.mixer', 'lesson.page.mixer'].indexOf(Editor.option) !== -1;
      }
    };

    return editorDragPanel;
  }
]);




// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/editorDragPanel.js